import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Snapshot, SnapshotMonitor } from 'types';

export const getMonitor = async ({
  snapshotId,
  monitorId,
}: {
  snapshotId: number;
  monitorId: number;
}): Promise<SnapshotMonitor> => {
  const { data }: { data: Snapshot } = await axios.get(
    `/api/snapshots/${snapshotId}`
  );
  const monitor = data?.monitors.find((monitor) => monitor.id === monitorId);
  return monitor as SnapshotMonitor;
};

type QueryFnType = typeof getMonitor;

type UseMonitorOptions = {
  snapshotId: number;
  monitorId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useMonitor = ({
  snapshotId,
  monitorId,
  config,
}: UseMonitorOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['snapshot', snapshotId, 'monitor', monitorId],
    queryFn: () => getMonitor({ snapshotId, monitorId }),
  });
};
